var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InfraBreadcrumbContainer',{attrs:{"grey-background":true,"items":_vm.breadcrumbItems}},[_c('generic-banner',{attrs:{"header":_vm.$t('individual-rights.heading'),"description":_vm.$t('individual-rights.description')}})],1),_c('div',{staticClass:"form-container"},[(_vm.html)?_c(_vm.form,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }